import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const BankTransactionSchema = withDefaults({
  type: 'bank-transaction',
  objectExtensions: ['bank-transaction'],
  fields: [
    {
      kind: 'attribute',
      name: 'bankAccount',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'transactionType',
    },
    {
      kind: 'attribute',
      name: 'transactionSubtype',
    },
    {
      kind: 'attribute',
      name: 'bankReference',
    },
    {
      kind: 'attribute',
      name: 'customerReference',
    },
    {
      kind: 'attribute',
      name: 'addendaData',
    },
    {
      kind: 'attribute',
      name: 'tioData',
    },
    {
      kind: 'attribute',
      name: 'details',
    },
    {
      kind: 'attribute',
      name: 'transactionDate',
    },
    {
      kind: 'attribute',
      name: 'availableDate',
    },
    {
      kind: 'attribute',
      name: 'originatorId',
    },
    {
      kind: 'attribute',
      name: 'originatorBank',
    },
    {
      kind: 'attribute',
      name: 'originatorName',
    },
    {
      kind: 'attribute',
      name: 'bankFileId',
    },
  ],
});

export default BankTransactionSchema;
